export const BASE_URL = 'https://api.commerce7.com';

export const TENANT_ID_PROD = 'rombauer-vineyards';
export const TENANT_ID_STAGE = 'staging-rombauer';

export const COOKIE_NAME_CUSTOMER_TOKEN = 'customerToken';
export const COOKIE_NAME_CLUB_SIGNUP_ID = 'clubSignupId';